import { about } from "../data/portfolio";

export default function About() {
  return (
    <section className="section about" id="about" aria-labelledby="about-title">
      <div className="section__inner about__grid">
        <header className="about__heading" data-reveal>
          <p className="section-kicker">01 / About</p>
          <h2 id="about-title">About</h2>
        </header>

        <div className="about__content">
          <p className="about__lead" data-reveal>
            {about.text}
          </p>
          <div className="about__meta" data-reveal>
            <p>{about.skills}</p>
            <p>{about.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
